<form [formGroup]="changePasswordForm" autocomplete="off">

    <!-- =========================
         CLOSE BUTTON
    ========================== -->

    <button
        type="button"
        class="close-btn"
        aria-label="Close"
        (click)="closeModal()">

        <i class="fa-solid fa-xmark"></i>

    </button>

    <!-- =========================
         MODAL
    ========================== -->

    <div class="password-modal">

        <!-- =========================
             HEADER
        ========================== -->

        <div class="password-header">

            <div class="lock-icon">

                <i class="fa-solid fa-lock"></i>

            </div>

            <h2>

                {{ hasPassword ? 'Update Password' : 'Set Password' }}

            </h2>

            <p>

                {{
                hasPassword
                ? 'Update your password to keep your account secure.'
                : 'Create a strong password to secure your account.'
                }}

            </p>

            <div class="header-divider"></div>

        </div>

        <!-- =========================
             OLD PASSWORD
        ========================== -->

        <div
            class="form-group"
            *ngIf="hasPassword">

            <label>

                Old Password

            </label>

            <div class="password-input">

                <input
                    class="form-control"
                    formControlName="oldPwd"
                    [type]="showOldPassword ? 'text' : 'password'"
                    placeholder="Enter your current password"
                    (keyup)="toggleAlert()">

                <button
                    type="button"
                    class="eye-btn"
                    (click)="showOldPassword=!showOldPassword">

                    <i
                        class="fa-regular"
                        [ngClass]="showOldPassword ? 'fa-eye-slash' : 'fa-eye'">
                    </i>

                </button>

            </div>

            <small class="helper-text">

                Enter your existing password.

            </small>

            <div
                class="alert alert-danger"
                *ngIf="oldPwd?.touched && oldPwd?.errors?.['required']">

                Old Password is required.

            </div>

            <div
                class="alert alert-danger"
                *ngIf="!isOldPawordValid">

                Old Password is incorrect.

            </div>

        </div>

        <!-- =========================
             NEW PASSWORD
        ========================== -->

        <div class="form-group">

            <label>

                {{ hasPassword ? 'New Password' : 'Password' }}

            </label>

            <div class="password-input">

                <input
                    class="form-control"
                    formControlName="newPwd"
                    [type]="showNewPassword ? 'text' : 'password'"
                    placeholder="Enter your password">

                <button
                    type="button"
                    class="eye-btn"
                    (click)="showNewPassword=!showNewPassword">

                    <i
                        class="fa-regular"
                        [ngClass]="showNewPassword ? 'fa-eye-slash' : 'fa-eye'">
                    </i>

                </button>

            </div>

            <div
                class="alert alert-danger"
                *ngIf="newPwd?.touched && newPwd?.errors?.['required']">

                Password is required.

            </div>

        </div>

        <!-- =========================
             PASSWORD STRENGTH
        ========================== -->

        <div
            class="password-strength"
            *ngIf="newPwd?.value">

            <div class="strength-bars">

                <span
                    *ngFor="let step of [1, 2, 3, 4]"
                    [ngClass]="{
                        active: passwordStrengthScore >= step,
                        weak: passwordStrengthScore <= 1 && step === 1,
                        fair: passwordStrengthScore === 2 && step <= 2,
                        good: passwordStrengthScore === 3 && step <= 3,
                        strong: passwordStrengthScore >= 4 && step <= 4
                    }">
                </span>

            </div>

            <span class="strength-text">

                {{ passwordStrengthMessage || passwordStrengthLabel }}

            </span>

        </div>

        <!-- =========================
             CONFIRM PASSWORD
        ========================== -->

        <div class="form-group">

            <label>

                Confirm Password

            </label>

            <div class="password-input">

                <input
                    class="form-control"
                    formControlName="confirmPwd"
                    [type]="showConfirmPassword ? 'text' : 'password'"
                    placeholder="Confirm your password">

                <button
                    type="button"
                    class="eye-btn"
                    (click)="showConfirmPassword=!showConfirmPassword">

                    <i
                        class="fa-regular"
                        [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'">
                    </i>

                </button>

            </div>

            <div
                class="alert alert-danger"
                *ngIf="confirmPwd?.touched && confirmPwd?.errors?.['required']">

                Confirm Password is required.

            </div>

            <div
                class="alert alert-danger"
                *ngIf="
                    confirmPwd?.value &&
                    changePasswordForm.errors?.['passwordsNotMatching']
                ">

                Passwords do not match.

            </div>

        </div>

        <!-- =========================
             PASSWORD TIPS
        ========================== -->

        <div class="password-tips">

            <div class="tip-icon">

                <i class="fa-solid fa-shield-halved"></i>

            </div>

            <div class="tip-content">

                <h6>

                    Password Tips

                </h6>

                <ul>

                    <li>Minimum 8 characters</li>

                    <li>Use uppercase & lowercase letters</li>

                    <li>Include numbers</li>

                    <li>Add special characters (! @ # $ %)</li>

                </ul>

            </div>

        </div>

        <!-- =========================
             ACTION BUTTON
        ========================== -->

        <button
            type="button"
            class="btn-change-password"
            (click)="ChangePassword()"
            [disabled]="changePasswordForm.invalid || isCPBtnDisable">

            <i class="fa-solid fa-lock"></i>

            <span>

                {{ hasPassword ? 'Update Password' : 'Set Password' }}

            </span>

        </button>

    </div>

</form>
